(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vikst-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vfi-section]').forEach(function (section) {
      var lb = section.querySelector('.vikst-fi-lb');
      var dataEl = section.querySelector('.vikst-fi__data');
      if (!lb || !dataEl) return;

      var slides = [];
      try {
        slides = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('vikst-fi: bad slide data', e);
        return;
      }
      if (!slides.length) return;

      var imgs = section.querySelectorAll('.vikst-fi__img[data-src]');
      function reveal(img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.complete && img.naturalWidth) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                reveal(entry.target);
                io.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '400px 0px', threshold: 0.01 }
        );
        imgs.forEach(function (i) { io.observe(i); });
      } else {
        imgs.forEach(reveal);
      }

      var title = lb.querySelector('.vikst-fi-lb__title');
      var cur = lb.querySelector('.vikst-fi-lb__current');
      var prevArrow = lb.querySelector('.vikst-fi-lb__arrow--prev');
      var nextArrow = lb.querySelector('.vikst-fi-lb__arrow--next');
      var tapPrev = lb.querySelector('.vikst-fi-lb__tap--prev');
      var tapNext = lb.querySelector('.vikst-fi-lb__tap--next');
      var stage = lb.querySelector('[data-lb-stage]');
      var track = lb.querySelector('[data-lb-track]');
      var slidePrev = lb.querySelector('[data-lb-slide="prev"] img');
      var slideCurr = lb.querySelector('[data-lb-slide="current"] img');
      var slideNext = lb.querySelector('[data-lb-slide="next"] img');
      var idx = 0;
      var isAnimating = false;
      var pending = 0;

      function mod(n) { return ((n % slides.length) + slides.length) % slides.length; }

      function paint() {
        var s = slides[idx] || {};
        slideCurr.src = s.src || '';
        slidePrev.src = (slides[mod(idx - 1)] || {}).src || '';
        slideNext.src = (slides[mod(idx + 1)] || {}).src || '';
        title.textContent = s.caption || '';
        if (cur) cur.textContent = idx + 1;
      }

      function setTrack(offsetPx, animate) {
        track.classList.toggle('is-animating', !!animate);
        track.style.transform = 'translate3d(calc(-33.3333% + ' + offsetPx + 'px), 0, 0)';
      }

      function startAnimation(dir) {
        isAnimating = true;
        var width = stage.clientWidth;
        var target = dir > 0 ? -width : width;
        setTrack(target, true);

        var fallback;
        function finish(e) {
          if (e && e.target !== track) return;
          if (e && e.propertyName && e.propertyName !== 'transform') return;
          track.removeEventListener('transitionend', finish);
          clearTimeout(fallback);

          idx = mod(idx + dir);
          track.classList.remove('is-animating');
          paint();
          setTrack(0, false);
          void track.offsetWidth;
          isAnimating = false;

          if (pending !== 0) {
            var step = pending > 0 ? 1 : -1;
            pending -= step;
            requestAnimationFrame(function () { startAnimation(step); });
          }
        }

        track.addEventListener('transitionend', finish);
        fallback = setTimeout(finish, 500);
      }

      function go(dir) {
        if (!dir) return;
        if (isAnimating) { pending += dir; return; }
        startAnimation(dir);
      }

      function open(i) {
        idx = mod(i);
        pending = 0;
        isAnimating = false;
        paint();
        setTrack(0, false);
        void track.offsetWidth;
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        lb.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      section.querySelectorAll('[data-lb-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          open(parseInt(btn.getAttribute('data-lb-open'), 10) || 0);
        });
      });
      lb.querySelectorAll('[data-lb-close]').forEach(function (el) { el.addEventListener('click', close); });
      if (prevArrow) prevArrow.addEventListener('click', function () { go(-1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { go(1); });
      if (tapPrev) tapPrev.addEventListener('click', function () { go(-1); });
      if (tapNext) tapNext.addEventListener('click', function () { go(1); });

      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') go(1);
        if (e.key === 'ArrowLeft') go(-1);
      });

      var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false, locked = false;

      stage.addEventListener('touchstart', function (e) {
        if (isAnimating) return;
        var t = e.touches[0];
        startX = t.clientX; startY = t.clientY;
        dx = 0; dy = 0; dragging = true; locked = false;
      }, { passive: true });

      stage.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var t = e.touches[0];
        dx = t.clientX - startX;
        dy = t.clientY - startY;
        if (!locked) {
          if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
            locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
        }
        if (locked === 'x') {
          if (e.cancelable) e.preventDefault();
          setTrack(dx, false);
        }
      }, { passive: false });

      stage.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        if (locked !== 'x') { setTrack(0, true); return; }
        var threshold = Math.min(120, stage.clientWidth * 0.2);
        if (dx <= -threshold) go(1);
        else if (dx >= threshold) go(-1);
        else setTrack(0, true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vikst-grid-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vec-section]').forEach(function (section) {
      var lightboxes = section.querySelectorAll('.vikst-lb');

      lightboxes.forEach(function (lb) {
        var dataEl = lb.querySelector('.vikst-lb__data');
        if (!dataEl) return;
        var slides = [];
        try {
          slides = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        if (!slides.length) return;

        var stage = lb.querySelector('[data-lb-stage]');
        var track = lb.querySelector('[data-lb-track]');
        var slidePrev = lb.querySelector('[data-lb-slide="prev"] img');
        var slideCurr = lb.querySelector('[data-lb-slide="current"] img');
        var slideNext = lb.querySelector('[data-lb-slide="next"] img');
        var cur = lb.querySelector('.vikst-lb__current');
        var prevArrow = lb.querySelector('.vikst-lb__arrow--prev');
        var nextArrow = lb.querySelector('.vikst-lb__arrow--next');
        var tapPrev = lb.querySelector('.vikst-lb__tap--prev');
        var tapNext = lb.querySelector('.vikst-lb__tap--next');

        var idx = 0;
        var isAnimating = false;
        var pending = 0;

        function mod(n) {
          return ((n % slides.length) + slides.length) % slides.length;
        }

        function paint() {
          slideCurr.src = slides[idx] || '';
          slidePrev.src = slides[mod(idx - 1)] || '';
          slideNext.src = slides[mod(idx + 1)] || '';
          if (cur) cur.textContent = idx + 1;
        }

        function setTrack(offsetPx, animate) {
          track.classList.toggle('is-animating', !!animate);
          track.style.transform = 'translate3d(calc(-33.3333% + ' + offsetPx + 'px), 0, 0)';
        }

        function go(dir) {
          if (!dir) return;
          if (isAnimating) {
            pending += dir;
            return;
          }
          isAnimating = true;
          var width = stage.clientWidth;
          var target = dir > 0 ? -width : width;
          setTrack(target, true);

          function finish(e) {
            if (e && e.target !== track) return;
            if (e && e.propertyName && e.propertyName !== 'transform') return;
            track.removeEventListener('transitionend', finish);
            clearTimeout(fallback);

            idx = mod(idx + dir);
            track.classList.remove('is-animating');
            paint();
            setTrack(0, false);
            isAnimating = false;

            if (pending !== 0) {
              var step = pending > 0 ? 1 : -1;
              pending -= step;
              go(step);
            }
          }

          track.addEventListener('transitionend', finish);
          var fallback = setTimeout(finish, 500);
        }

        function open() {
          idx = 0;
          pending = 0;
          isAnimating = false;
          paint();
          setTrack(0, false);
          lb.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        function close() {
          lb.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        lb._open = open;
        lb._close = close;
        lb._go = go;

        lb.querySelectorAll('[data-lb-close]').forEach(function (el) {
          el.addEventListener('click', close);
        });
        if (prevArrow) prevArrow.addEventListener('click', function () { go(-1); });
        if (nextArrow) nextArrow.addEventListener('click', function () { go(1); });
        if (tapPrev) tapPrev.addEventListener('click', function () { go(-1); });
        if (tapNext) tapNext.addEventListener('click', function () { go(1); });

        /* Touch swipe */
        var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false, locked = false;

        stage.addEventListener('touchstart', function (e) {
          if (isAnimating) return;
          var t = e.touches[0];
          startX = t.clientX; startY = t.clientY;
          dx = 0; dy = 0; dragging = true; locked = false;
        }, { passive: true });

        stage.addEventListener('touchmove', function (e) {
          if (!dragging) return;
          var t = e.touches[0];
          dx = t.clientX - startX;
          dy = t.clientY - startY;
          if (!locked) {
            if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
              locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            }
          }
          if (locked === 'x') {
            if (e.cancelable) e.preventDefault();
            setTrack(dx, false);
          }
        }, { passive: false });

        stage.addEventListener('touchend', function () {
          if (!dragging) return;
          dragging = false;
          if (locked !== 'x') { setTrack(0, true); return; }
          var threshold = Math.min(120, stage.clientWidth * 0.2);
          if (dx <= -threshold) go(1);
          else if (dx >= threshold) go(-1);
          else setTrack(0, true);
        });
      });

      /* Open from triggers */
      section.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-lookbook-trigger]');
        if (!trigger) return;
        var id = trigger.getAttribute('data-lookbook-trigger');
        var lb = document.getElementById('lookbook-' + id);
        if (lb && lb._open) lb._open();
      });

      document.addEventListener('keydown', function (e) {
        var lb = document.querySelector('.vikst-lb.is-open');
        if (!lb) return;
        if (e.key === 'Escape' && lb._close) lb._close();
        if (e.key === 'ArrowRight' && lb._go) lb._go(1);
        if (e.key === 'ArrowLeft' && lb._go) lb._go(-1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
